'use strict';

exports.__esModule = true;
exports.applyUpdaterToNextProps = applyUpdaterToNextProps;
exports.registerEvents = registerEvents;
exports.unregisterEvents = unregisterEvents;
exports.applyUpdatersToPropsAndRegisterEvents = applyUpdatersToPropsAndRegisterEvents;
/* global google */
function reduce(obj, fn, acc) {
	return Object.keys(obj).reduce(function (newAcc, key) {
		return fn(newAcc, obj[key], key);
	}, acc);
}

function forEach(obj, fn) {
	Object.keys(obj).forEach(function (key) {
		return fn(obj[key], key);
	});
}
function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
	var map = {};

	var iter = function iter(fn, key) {
		var nextValue = nextProps[key];

		if (nextValue !== prevProps[key]) {
			map[key] = nextValue;
			fn(instance, nextValue);
		}
	};

	forEach(updaterMap, iter);

	return map;
}

function registerEvents(props, instance, eventMap) {
	var registeredList = reduce(eventMap, function (acc, googleEventName, onEventName) {
		if (typeof props[onEventName] === 'function') {
			acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
		}

		return acc;
	}, []);

	return registeredList;
}

function unregisterEvent(registered) {
	google.maps.event.removeListener(registered);
}

function unregisterEvents() {
	var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	events.forEach(unregisterEvent);
}

function applyUpdatersToPropsAndRegisterEvents(_ref) {
	var updaterMap = _ref.updaterMap,
	    eventMap = _ref.eventMap,
	    prevProps = _ref.prevProps,
	    nextProps = _ref.nextProps,
	    instance = _ref.instance;

	var registeredEvents = registerEvents(nextProps, instance, eventMap);

	applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);

	return registeredEvents;
}